import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "container-left" }
const _hoisted_3 = {
  key: 0,
  class: "column-left"
}
const _hoisted_4 = { class: "container-right" }
const _hoisted_5 = {
  key: 0,
  class: "column-right"
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AnimatedBar',
  props: {
    showLeft: { type: Boolean, default: true },
    showRight: { type: Boolean, default: true },
    showMiddle: { type: Boolean, default: true }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.showLeft)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _renderSlot(_ctx.$slots, "left")
          ]))
        : _createCommentVNode("", true),
      (_ctx.showMiddle)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["column-middle", { 'left-hidden': !_ctx.showLeft }])
          }, [
            _renderSlot(_ctx.$slots, "middle")
          ], 2))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_ctx.showRight)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _renderSlot(_ctx.$slots, "right")
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})